import { IReportsRepository } from "../../repositories/reports_repository";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { IGetReportTreinamentosUseCase } from "../../../presentation/useCases/read/get_report_treinamentos_use_case";
import { RangedDate } from "../../../../../common/utils/ranged_date_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { ReportData } from "../../models/report_data";

import dayjs from "dayjs";

/**
 * GetReportTreinamentosUseCase
 */

export class GetReportTreinamentosUseCase implements IGetReportTreinamentosUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportTreinamentos(
    requiredMimeType: ReportMimeType | null,
    idUsuario: number,
    status: number[] | null,
    nome: number[] | null,
    centroCusto: number[] | null,
    eficaz: number[] | null,
    treinamentos: number[] | null,
    cargos: number[] | null,
    dataTreinamento: RangedDate,
  ): Promise<ReportData> {
    const response = await this.repository.getReportTreinamentos(
      requiredMimeType,
      idUsuario,
      nome,
      status?.length === 2 ? [...status, 2] : status,
      dataTreinamento.dataDe,
      dataTreinamento.dataAte,
      centroCusto,
      eficaz?.length === 2 ? [...eficaz, 2] : eficaz,
      treinamentos,
      cargos,
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `treinamentos_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
